import {
  SequenceLeadsData,
  SequenceLeadsStatusEmail,
  SequenceLeadsStatusSms,
  SequenceLeadsStatusVoice,
  SequenceLeadsStatusWhatsapp,
  SequenceNode,
  SequenceNodeAction,
  SequenceNodeType,
} from "@/@types/flows/sequences";
import { ContactStatus } from "@/app/flows/sequences/utils/enums";
import { SequenceState } from "@/@types/flows/sequences";

export const NodeNameByType: Record<SequenceNodeType, string> = {
  [SequenceNodeType.TimeInterval]: "Tiempo de espera",
  [SequenceNodeType.AutomaticCall]: "Llamada automática",
  [SequenceNodeType.Email]: "Correo electrónico",
  [SequenceNodeType.Whatsapp]: "Mensaje de whatsapp",
  [SequenceNodeType.Sms]: "Mensaje de sms",
};

export const NodeTitleByType: Record<SequenceNodeType, string> = {
  [SequenceNodeType.TimeInterval]: "Tiempo de espera",
  [SequenceNodeType.AutomaticCall]: "Llamada automática",
  [SequenceNodeType.Email]: "Correo electrónico",
  [SequenceNodeType.Whatsapp]: "Mensaje de WhatsApp",
  [SequenceNodeType.Sms]: "SMS",
};

export const NodeAbreviationByType: Record<SequenceNodeType, string> = {
  [SequenceNodeType.TimeInterval]: "TE",
  [SequenceNodeType.AutomaticCall]: "LA",
  [SequenceNodeType.Email]: "CE",
  [SequenceNodeType.Whatsapp]: "MW",
  [SequenceNodeType.Sms]: "MS",
};

export const ActionNameByType: Record<SequenceNodeAction, string> = {
  [SequenceNodeAction.Finish]: "Finalizar secuencia",
  [SequenceNodeAction.MakeAutomaticCall]: "Llamada automática",
  [SequenceNodeAction.SendEmail]: "Enviar correo electrónico",
  [SequenceNodeAction.SendWhatsapp]: "Enviar plantilla de whatsapp",
  [SequenceNodeAction.SendSms]: "Enviar mensaje de SMS",
  [SequenceNodeAction.AddTimeInterval]: "Agregar tiempo de espera",
};

export const getNodeDescription = (node: SequenceNode) => {
  if (node.type === SequenceNodeType.TimeInterval) {
    if (!node.waiting_time) return "00:00 hrs";

    const [hour, minute] = node.waiting_time.split(":");

    return `${hour}:${minute} hrs`;
  }
  if (node.type === SequenceNodeType.AutomaticCall) return "Llamada saliente";
  if (node.type === SequenceNodeType.Whatsapp) {
    const queue = node.queue?.name ? `Cola: ${node.queue?.name}` : "-";
    const template = node.whatsapp_template?.name
      ? `Plantilla: ${node.whatsapp_template?.name}`
      : "-";
    return queue + " / " + template;
  }
  if (node.type === SequenceNodeType.Email)
    return node.email_template?.name ? `Plantilla: ${node.email_template?.name}` : 
      (node.email_message?.length > 0 ? `Redacción de correo manual` : "-");
  if (node.type === SequenceNodeType.Sms) return "SMS saliente";
  return "-";
};

export const ContactStatusTag = {
  [ContactStatus.Pending]: {
    color: "default",
    title: "Pendiente",
  },
  [ContactStatus.InProgress]: {
    color: "warning",
    title: "En curso",
  },
  [ContactStatus.Contacted]: {
    color: "success",
    title: "Contactado",
  },
  [ContactStatus.Finalized]: {
    color: "processing",
    title: "Finalizado",
  },
};

export const SequenceStateText: Record<SequenceState, string> = {
  [SequenceState.Pending]: "Pendiente",
  [SequenceState.InProgress]: "En curso",
  [SequenceState.Contacted]: "Finalizado contactado",
  [SequenceState.NotContacted]: "Finalizado no contactado",
};

export const SequenceLeadsDataText: Record<SequenceLeadsData, string> = {
  [SequenceLeadsData.PendingLeads]: "Pendientes",
  [SequenceLeadsData.InProgressLeads]: "En curso",
  [SequenceLeadsData.ContactedLeads]: "Contactados",
  [SequenceLeadsData.EndedLeads]: "Finalizados",
};

export const SequenceLeadsDataInfo: Record<SequenceLeadsData, string> = {
  [SequenceLeadsData.PendingLeads]: "Contactos ingresados a la secuencia.",
  [SequenceLeadsData.InProgressLeads]: "Contactos que iniciaron el proceso de la secuencia.",
  [SequenceLeadsData.ContactedLeads]: "Contactos que respondieron durante la secuencia.",
  [SequenceLeadsData.EndedLeads]: "Contactos que terminaron la secuencia, sin respuesta.",
};

export const SequenceLeadsStatusVoiceText: Record<SequenceLeadsStatusVoice, string> = {
  [SequenceLeadsStatusVoice.Dial]: "Marcando",
  [SequenceLeadsStatusVoice.Answer]: "Contestadas",
  [SequenceLeadsStatusVoice.NoAnswer]: "No contacto",
  [SequenceLeadsStatusVoice.WithoutPhone]: "Sin teléfono",
};

export const SequenceLeadsStatusEmailText: Record<SequenceLeadsStatusEmail, string> = {
  [SequenceLeadsStatusEmail.Sent]: "Enviados",
  [SequenceLeadsStatusEmail.Open]: "Abiertos",
  [SequenceLeadsStatusEmail.Click]: "Click",
  [SequenceLeadsStatusEmail.Answer]: "Respondidos",
  [SequenceLeadsStatusEmail.Failed]: "Rebote",
  [SequenceLeadsStatusEmail.WithoutEmail]: "Sin correo",
};

export const SequenceLeadsStatusWhatsappText: Record<SequenceLeadsStatusWhatsapp, string> = {
  [SequenceLeadsStatusWhatsapp.Sent]: "Enviados",
  [SequenceLeadsStatusWhatsapp.Pending]: "No enviados",
  [SequenceLeadsStatusWhatsapp.Delivered]: "Recibido",
  [SequenceLeadsStatusWhatsapp.Read]: "Leído",
  [SequenceLeadsStatusWhatsapp.Failed]: "Fallido",
  [SequenceLeadsStatusWhatsapp.WithoutPhone]: "Sin teléfono",
};

export const SequenceLeadsStatusSmsText: Record<SequenceLeadsStatusSms, string> = {
  [SequenceLeadsStatusSms.Sent]: "Enviados",
  [SequenceLeadsStatusSms.Pending]: "No enviados",
  [SequenceLeadsStatusSms.Delivered]: "Recibido",
  [SequenceLeadsStatusSms.Failed]: "Fallido",
  [SequenceLeadsStatusSms.WithoutPhone]: "Sin teléfono",
};
